<template>
  <v-card>
    <v-card-title class="align-start">
      <p class="primary--text tituloCatalogo">Catálogo</p>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col v-for="data in statisticsData" :key="data.title" cols="6" md="3" class="d-flex align-center">
          <v-avatar size="44" :color="resolveStatisticsIconVariation(data.title).color" rounded class="elevation-1">
            <v-icon dark color="white" size="30">
              {{ resolveStatisticsIconVariation(data.title).icon }}
            </v-icon>
          </v-avatar>
          <div class="ms-3">
            <p class="text-xs mb-0">
              {{ data.title }}
            </p>
            <v-skeleton-loader max-width="100%" type="text" v-show="loading"></v-skeleton-loader>
            <h3 v-show="!loading" class="text-xl font-weight-semibold">
              {{ data.total }}
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiAccountOutline,
  mdiCurrencyUsd,
  mdiTrendingUp,
  mdiDotsVertical,
  mdiLabelOutline,
  mdiFormSelect,
} from '@mdi/js'
import helpers from '../../mixins/helpers'

export default {
  mixins: [helpers],
  data() {
    return {
      statisticsData: [
        {
          title: 'Total de productos',
          total: '245k',
        },
        {
          title: 'Productos vigentes',
          total: '12.5k',
        },
        {
          title: 'Productos por caducar',
          total: '1.54k',
        },
        {
          title: 'Productos caducos',
          total: '88k',
        },
      ],
      loading: true,
      // icons
      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiAccountOutline,
        mdiLabelOutline,
        mdiCurrencyUsd,
        mdiFormSelect,
      },
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true
      let url = `${this.$base_api_url}/getGeneralInfoAboutProducts`

      this.$http
        .post(url)
        .then(res => {
          this.statisticsData[0].total = res.data.total
          this.statisticsData[1].total = res.data.valid_products
          this.statisticsData[2].total = res.data.expiring_products
          this.statisticsData[3].total = res.data.products_expired
        })
        .catch(res => {
          this.catchResponse(res)
        })
        .then(() => {
          this.loading = false
        })
    },
    resolveStatisticsIconVariation: data => {
      if (data === 'Total de productos') return { icon: mdiFormSelect, color: 'primary' }
      if (data === 'Productos vigentes') return { icon: mdiFormSelect, color: 'success' }
      if (data === 'Productos por caducar') return { icon: mdiFormSelect, color: 'warning' }
      if (data === 'Productos caducos') return { icon: mdiFormSelect, color: 'error' }

      return { icon: mdiAccountOutline, color: 'success' }
    },
  },
}
</script>
<style>
.tituloCatalogo {
  font-size: 1.5em !important;
}
</style>
